(function () {
    'use strict';

    angular
        .module('app')
        .controller('ImportEntityDialogCtrl', ImportEntityDialogCtrl);

    ImportEntityDialogCtrl.$inject = ['DialogInstance', 'DialogService', 'EntitiesService', 'entityTemplate', 'file'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog prompting the user to confirm they want to import the entities
     * 
     */
    function ImportEntityDialogCtrl(DialogInstance, DialogService, EntitiesService, entityTemplate, file) {
        /* jshint validthis:true */
        var vm = this;
        vm.entityTemplate = entityTemplate;
        vm.loading = true;
        vm.disableOk = true;
        vm.showValidationReport = false;
        vm.showImportReport = false;
        vm.titlePrefix = 'Import';
        vm.okText = 'Import';
        vm.formatIgnoredColumnsString = formatIgnoredColumnsString;
        vm.allChangedEntitiesSelected = false;
        vm.ok = ok;
        vm.cancel = cancel;

        Object.defineProperty(vm, 'title', {
            get: function () {
                return vm.titlePrefix + ' - ' + vm.entityTemplate.PluralName;
            }
        });

        activate();

        function activate() {
            validateImportEntities().finally(function () {
                vm.loading = false;
            });
        }

        function validateImportEntities() {
            return EntitiesService.validateImportEntities(entityTemplate.Id, file)
                .then(getValidationReportOk, getValidationReportError);

            function getValidationReportOk(response) {
                vm.validationReport = response.data;
                vm.showValidationReport = true;
                vm.disableOk = false;

                if (!_.isNil(vm.validationReport.Errors) && vm.validationReport.Errors.length > 0) {
                    vm.okText = 'Close';
                }
            }

            function getValidationReportError(response) {
                DialogService.error('Error validating import for ' + entityTemplate.PluralName + '.', response)
                    .finally(function () {
                        DialogInstance.cancel();
                    });
            }
        }

        function importEntities() {
            vm.titlePrefix = 'Importing';
            var entitiesToExclude = [];
            if (vm.validationReport && vm.validationReport.EntitiesChanged) {
                for (var i = 0; i < vm.validationReport.EntitiesChanged.length; i++) {
                    if (!vm.validationReport.EntitiesChanged[i].Selected) {
                        entitiesToExclude.push(vm.validationReport.EntitiesChanged[i].Id);
                    }
                }
            }

            return EntitiesService.importEntities(entityTemplate.Id, file, entitiesToExclude)
                .then(importOk, importError);

            function importOk(response) {
                vm.titlePrefix = 'Imported';
                vm.loading = false;
                vm.showImportReport = true;
                vm.okText = 'Close';
                vm.disableOk = false;
                vm.importReport = response.data;
            }

            function importError(response) {
                DialogService.error('Error importing for ' + entityTemplate.PluralName + '.', response)
                    .finally(function () {
                        DialogInstance.cancel();
                    });
            }
        }

        /*
         * Converts the ignored columns list into a user readable string
         *
         * @returns {string} - Returns the list of ignored columns in a user readable string
         */
        function formatIgnoredColumnsString(ignoredColumns) {
            return _.reduce(ignoredColumns, function (memo, ignoredColumn) {
                if (!_.isNil(memo) && memo !== '') {
                    memo += ', ';
                }

                return memo += ignoredColumn;
            });
        }

        function ok() {
            if (vm.okText === 'Import') {
                vm.okText = 'Importing';
                vm.loading = true;
                vm.disableOk = true;

                return importEntities().then(function () {
                    vm.okText = 'Close';
                    vm.showValidationReport = false;
                    vm.loading = false;
                    vm.disableOk = false;
                });
            } else {
                DialogInstance.ok(true);
            }
        }

        function cancel() {
            if (vm.okText === 'Close')
                DialogInstance.ok(true);

            DialogInstance.cancel();
        }
    }
})();
